(function () {
"use strict";
var $3d28d7f1aac198f5$exports = {};
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


"use strict";
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        var EMPTY_BOARD = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.board = initialState ? this.deepCopy(initialState) : this.deepCopy(EMPTY_BOARD);
        this.initialBoardState = this.deepCopy(this.board);
        this.score = 0;
        this.status = "idle";
        this.isStarted = false;
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "deepCopy",
            value: function deepCopy(arr) {
                return arr.map(function(row) {
                    return row.slice();
                });
            }
        },
        {
            key: "generateNewTile",
            value: function generateNewTile() {
                var emptyCells = [];
                for(var r = 0; r < 4; r++){
                    for(var c = 0; c < 4; c++)if (this.board[r][c] === 0) emptyCells.push({
                        row: r,
                        col: c
                    });
                }
                if (emptyCells.length === 0) return false;
                var randomIndex = Math.floor(Math.random() * emptyCells.length);
                var _emptyCells_randomIndex = emptyCells[randomIndex], row = _emptyCells_randomIndex.row, col = _emptyCells_randomIndex.col;
                var newValue = Math.random() < 0.1 ? 4 : 2;
                this.board[row][col] = newValue;
                return true;
            }
        },
        {
            key: "processLine",
            value: function processLine(line) {
                var scoreChange = 0;
                var filtredLine = line.filter(function(value) {
                    return value !== 0;
                });
                for(var i = 0; i < filtredLine.length - 1; i++)if (filtredLine[i] === filtredLine[i + 1]) {
                    filtredLine[i] *= 2;
                    scoreChange += filtredLine[i];
                    filtredLine[i + 1] = 0;
                }
                filtredLine = filtredLine.filter(function(value) {
                    return value !== 0;
                });
                while(filtredLine.length < 4)filtredLine.push(0);
                return {
                    newLine: filtredLine,
                    scoreChange: scoreChange
                };
            }
        },
        {
            key: "transposeBoard",
            value: function transposeBoard(board) {
                var newBoard = [
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ],
                    [
                        0,
                        0,
                        0,
                        0
                    ]
                ];
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++)newBoard[r][c] = board[c][r];
                return newBoard;
            }
        },
        {
            key: "checkWin",
            value: function checkWin() {
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    if (this.board[r][c] === 2048) {
                        this.status = "win";
                        return true;
                    }
                    var current = this.board[r][c];
                    if (c < 3 && this.board[r][c + 1] === current) return true;
                    if (r < 3 && this.board[r + 1][c] === current) return true;
                }
                return false;
            }
        },
        {
            key: "hasAvailableMoves",
            value: function hasAvailableMoves() {
                for(var r = 0; r < 4; r++)for(var c = 0; c < 4; c++){
                    if (this.board[r][c] === 0) return true;
                    var current = this.board[r][c];
                    if (c < 3 && this.board[r][c + 1] === current) return true;
                    if (r < 3 && this.board[r + 1][c] === current) return true;
                }
                return false;
            }
        },
        {
            key: "checkGameStatus",
            value: function checkGameStatus() {
                if (this.checkWin()) return;
                if (!this.hasAvailableMoves()) this.status = "lose";
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                if (this.status !== "playing") return false;
                var oldBoard = this.deepCopy(this.board);
                var boardChange = false;
                for(var row = 0; row < 4; row++){
                    var _this_processLine = this.processLine(this.board[row]), newLine = _this_processLine.newLine, scoreChange = _this_processLine.scoreChange;
                    this.score += scoreChange;
                    if (oldBoard[row].join(",") !== newLine.join(",")) boardChange = true;
                    this.board[row] = newLine;
                }
                if (boardChange) {
                    this.generateNewTile();
                    this.checkGameStatus();
                    return true;
                }
                return false;
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                if (this.status !== "playing") return false;
                var oldBoard = this.deepCopy(this.board);
                var boardChanged = false;
                for(var row = 0; row < 4; row++){
                    var line = this.board[row];
                    line.reverse();
                    var _this_processLine = this.processLine(line), newLine = _this_processLine.newLine, scoreChange = _this_processLine.scoreChange;
                    this.score += scoreChange;
                    newLine.reverse();
                    if (oldBoard[row].join(",") !== newLine.join(",")) boardChanged = true;
                    this.board[row] = newLine;
                }
                if (boardChanged) {
                    this.generateNewTile();
                    this.checkGameStatus();
                    return true;
                }
                return false;
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                if (this.status !== "playing") return false;
                var oldBoard = this.deepCopy(this.board);
                var boardChanged = false;
                this.board = this.transposeBoard(this.board);
                for(var row = 0; row < 4; row++){
                    var _this_processLine = this.processLine(this.board[row]), newLine = _this_processLine.newLine, scoreChange = _this_processLine.scoreChange;
                    this.score += scoreChange;
                    this.board[row] = newLine;
                }
                this.board = this.transposeBoard(this.board);
                for(var r = 0; r < 4; r++)if (oldBoard[r].join(",") !== this.board[r].join(",")) {
                    boardChanged = true;
                    break;
                }
                if (boardChanged) {
                    this.generateNewTile();
                    this.checkGameStatus();
                    return true;
                }
                return false;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                if (this.status !== "playing") return false;
                var oldBoard = this.deepCopy(this.board);
                var boardChanged = false;
                this.board = this.transposeBoard(this.board);
                for(var row = 0; row < 4; row++){
                    var line = this.board[row];
                    line.reverse();
                    var _this_processLine = this.processLine(line), newLine = _this_processLine.newLine, scoreChange = _this_processLine.scoreChange;
                    this.score += scoreChange;
                    newLine.reverse();
                    this.board[row] = newLine;
                }
                this.board = this.transposeBoard(this.board);
                for(var r = 0; r < 4; r++)if (oldBoard[r].join(",") !== this.board[r].join(",")) {
                    boardChanged = true;
                    break;
                }
                if (boardChanged) {
                    this.generateNewTile();
                    this.checkGameStatus();
                    return true;
                }
                return false;
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.generateNewTile();
                this.generateNewTile();
                this.status = "playing";
                this.isStarted = true;
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = this.initialBoardState.map(function(row) {
                    return row.slice();
                });
                this.score = 0;
                this.status = "idle";
                this.start();
            }
        }
    ]);
    return Game;
}();
$3d28d7f1aac198f5$exports = $3d28d7f1aac198f5$var$Game;


var $197cd56b15c33885$var$game = new $3d28d7f1aac198f5$exports();
var $197cd56b15c33885$var$gameField = document.querySelector(".game-field");
var $197cd56b15c33885$var$startButton = document.querySelector(".button");
var $197cd56b15c33885$var$scoreElement = document.querySelector(".game-score");
var $197cd56b15c33885$var$messageStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$messageWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$messageLose = document.querySelector(".message-lose");
function $197cd56b15c33885$var$hideAllMessages() {
    $197cd56b15c33885$var$messageStart.classList.add("hidden");
    $197cd56b15c33885$var$messageWin.classList.add("hidden");
    $197cd56b15c33885$var$messageLose.classList.add("hidden");
}
function $197cd56b15c33885$var$updateBoard() {
    var boardState = $197cd56b15c33885$var$game.getState();
    var cells = $197cd56b15c33885$var$gameField.querySelectorAll(".field-cell");
    cells.forEach(function(cell, index) {
        var row = Math.floor(index / 4);
        var col = index % 4;
        if (!boardState[row] || boardState[row][col] === undefined) return;
        var value = boardState[row][col];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value !== 0) cell.classList.add("field-cell--".concat(value));
    });
}
function $197cd56b15c33885$var$updateScore() {
    $197cd56b15c33885$var$scoreElement.textContent = $197cd56b15c33885$var$game.getScore();
}
function $197cd56b15c33885$var$updateStatus() {
    var st = $197cd56b15c33885$var$game.getStatus();
    if ($197cd56b15c33885$var$game.isStarted) {
        $197cd56b15c33885$var$startButton.textContent = "Restart";
        $197cd56b15c33885$var$startButton.classList.remove("start");
        $197cd56b15c33885$var$startButton.classList.add("restart");
    } else {
        $197cd56b15c33885$var$startButton.textContent = "Start";
        $197cd56b15c33885$var$startButton.classList.add("start");
        $197cd56b15c33885$var$startButton.classList.remove("restart");
    }
    $197cd56b15c33885$var$hideAllMessages();
    if (st === "win") $197cd56b15c33885$var$messageWin.classList.remove("hidden");
    else if (st === "lose") $197cd56b15c33885$var$messageLose.classList.remove("hidden");
    else if (st === "idle") $197cd56b15c33885$var$messageStart.classList.remove("hidden");
}
function $197cd56b15c33885$var$updateUI() {
    $197cd56b15c33885$var$updateBoard();
    $197cd56b15c33885$var$updateScore();
    $197cd56b15c33885$var$updateStatus();
}
function $197cd56b15c33885$var$handleStartClick() {
    if ($197cd56b15c33885$var$game.getStatus() === "playing" || $197cd56b15c33885$var$game.isStarted) $197cd56b15c33885$var$game.restart();
    else $197cd56b15c33885$var$game.start();
    $197cd56b15c33885$var$updateUI();
}
function $197cd56b15c33885$var$handleKeyDown(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== "playing") return;
    var moved = false;
    switch(e.key){
        case "ArrowRight":
            moved = $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowLeft":
            moved = $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowUp":
            moved = $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $197cd56b15c33885$var$game.moveDown();
            break;
        default:
            return;
    }
    if (moved) {
        e.preventDefault();
        $197cd56b15c33885$var$updateUI();
    }
}
function $197cd56b15c33885$var$init() {
    if (!$197cd56b15c33885$var$startButton || !$197cd56b15c33885$var$gameField || !$197cd56b15c33885$var$scoreElement) return;
    $197cd56b15c33885$var$startButton.addEventListener("click", $197cd56b15c33885$var$handleStartClick);
    document.addEventListener("keydown", $197cd56b15c33885$var$handleKeyDown);
    $197cd56b15c33885$var$updateUI();
}
$197cd56b15c33885$var$init();

})();
//# sourceMappingURL=index.a249ea9a.js.map
